import MuiTab, { TabProps, TabTypeMap } from '@mui/material/Tab';
import { OverridableComponent } from '@mui/material/OverridableComponent';

export { tabClasses } from '@mui/material/Tab';

export type { TabProps };

// Save MUI Tab’s polymorphic typing (for example: <Tab component={NavLink} to='foo' />)
// Export the design-system's Tab as MUI’s OverridableComponent instead of React.FC.
export const Tab: OverridableComponent<TabTypeMap> = MuiTab;
